import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Group, GroupItem } from '../../models';
import { SLICE_NAMES } from '../constants';
import { logger } from '@/utils';

export const groupsInitialState: Group[] = [];

const groupsSlice = createSlice({
  name: SLICE_NAMES.GROUPS,
  initialState: groupsInitialState,
  reducers: {
    setGroup: (state: Group[], action: PayloadAction<Group>) => {
      const index = state.findIndex(tmpG => tmpG.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      } else {
        state.push(action.payload);
      }
      return state;
    },
    setGroups: (state: Group[], action: PayloadAction<Group[]>) => {
      return [...action.payload];
    },
    removeGroup: (state: Group[], action: PayloadAction<string>) => {
      return state.filter(g => g.id !== action.payload);
    },
    addItemToGroup: (
      state: Group[],
      action: PayloadAction<{ groupId: string; item: GroupItem }>
    ) => {
      const index = state.findIndex(tmpG => tmpG.id === action.payload.groupId);
      if (index === -1) {
        logger.error('addItemToGroup: groupId not found in state', undefined, {
          extra: { groupId: action.payload.groupId },
        });
        return state;
      }
      state[index].items.push(action.payload.item);
      return state;
    },
    removeGroupItem: (
      state: Group[],
      action: PayloadAction<{ groupId: string; item: GroupItem }>
    ) => {
      const index = state.findIndex(tmpG => tmpG.id === action.payload.groupId);
      if (index === -1) {
        logger.error('removeGroupItem: groupId not found in state', undefined, {
          extra: { groupId: action.payload.groupId },
        });
        return state;
      }
      const { itemType, itemValue } = action.payload.item;
      state[index].items = state[index].items.filter(
        tmpItem =>
          tmpItem.itemType !== itemType || tmpItem.itemValue !== itemValue
      );
      return state;
    },
  },
});

export const {
  setGroup,
  setGroups,
  removeGroup,
  addItemToGroup,
  removeGroupItem,
} = groupsSlice.actions;

export const groupsReducer = groupsSlice.reducer;
